import React from "react";
import { TextField } from "@mui/material";
import { QrCodeQuestion } from "../../types";

interface QrCodeQuestionProps {
  question: QrCodeQuestion;
  value: string;
  onChange: (value: string) => void;
}

export const QrCodeQuestionField: React.FC<QrCodeQuestionProps> = ({
  question,
  value,
  onChange,
}) => (
  <TextField
    fullWidth
    placeholder={question.placeholder || "Enter joining code"}
    value={value}
    onChange={(event) => onChange(event.target.value)}
  />
);
